import Site from "../Site";
import Player720 from "./Player720";

export default class ProductPage {
    private static initProductGallery() {
        const $uid = $('.productgallery');
        const $preview = $('.productgallery__preview', $uid);
        const $thumbs = $('.productgallery__thumbs', $uid);

        $preview.on('init', () => {
            Site.discover($preview);
        });

        (<any> $preview).slick({
            infinite: true,
            dots: false,

            prevArrow: '<button type="button" class="slick-prev"><i class="xi xi-arrow-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="xi xi-arrow-right"></i></button>',

            asNavFor: '.productgallery__thumbs',
        });

        (<any> $thumbs).slick({
            infinite: false,
            dots: false,
            arrows: false,

            // centerPadding: 0,

            slidesToShow: 4,
            focusOnSelect: true,
            accessibility: true,

            vertical: true,
            verticalSwiping: true,

            centerMode: true,

            asNavFor: '.productgallery__preview',
        });

        if (window.innerWidth <= Site.MOBILE) {
            $uid.detach();
            $uid.insertAfter($('.vproduct__title'));
        }

        $uid.addClass('productgallery--inited');
    }

    private static initTexts(): void {
        const $pbody = $('.vproduct__body');

        let $texts = $('.vproduct__text');

        if (window.innerWidth <= Site.MOBILE) {
            let $prev: JQuery = null;
            let $techs: JQuery = null;

            $texts = $texts.filter((ix, el) => {
                const $el = $(el);

                if ($el.hasClass('vproduct__text--techs')) {
                    $techs = $el;
                    $el.detach();
                    return false;
                }

                const $title = $('> h2 span', $el);
                const title = $title.text().trim();
                const $content = $('.vproduct__text-body', $el);

                if (!title.length) {
                    if ($prev !== null) {
                        $prev.append($content);
                    }

                    $el.remove();
                    return false;
                }

                $prev = $el;

                return true;
            });

            $('.vproduct__text').each((ix, el) => {
                const $el = $(el);

                if ($el.closest($pbody).length == 0) {
                    $el.detach().appendTo($pbody);
                }
            });

            if ($techs != null) {
                $techs.prependTo($pbody);
            }
        }

        let $lastel: JQuery = null;

        $('.vproduct__text').each((ix, el) => {
            const $el = $(el);

            const $bar = $('> h2', $el);
            const $button = $('button', $bar);
            const $content = $('.vproduct__text-body', $el);

            $bar.on('click', (e) => {
                const vis = $content.is(':visible');

                if (vis) {
                    $content.slideUp();
                } else {
                    $content.slideDown();
                }

                $el.toggleClass('vproduct__text--opened', !vis);
                $button.text(vis ? '+' : '-');
            });

            $lastel = $el;
        });

        if ($lastel != null) {
            $lastel.addClass('vproduct__text--last');
        }

        let $contentbar = $('.vproduct__content .vproduct__text > h2');

        if ($contentbar.length) {
            $contentbar.trigger('click');
        }
    }

    private static initContentBox_Video($item: JQuery): void {
        const $videoel = $('.product-content__video', $item);

        if ($videoel.length) {
            let video: HTMLVideoElement = null;

            const src = $videoel.data('video');

            const $video = $(`<video muted loop autoplay playsinline></video>`);

            $video.on('canplay', () => {
                $video.prependTo($videoel);

                video = <HTMLVideoElement> $video.get(0);

                $item.addClass('product-content--video');

                video.play();
            });

            $video.append('<source src="' + src + '" type="video/mp4">');
        }
    }

    public static initContentBox_360($item: JQuery): void {
        const config_src: string = $item.data('config');

        $.get(config_src, (json) => {
            if (!json.frames) {
                throw "Unable to load " + config_src;
            }

            const path = config_src.substr(0, config_src.lastIndexOf('/'));

            json.path = path;

            const $wrap = $(`<div class="player720"></div>`);
            $wrap.prependTo($item);

            const p = new Player720(json);
            p.initHtml($wrap);
        });
    }

    private static initContentBoxes(): void {
        const $items = $('.product-content__item');

        $items.each((ix, el) => {
            const $item = $(el);

            if ($item.hasClass('product-content--video')) {
                this.initContentBox_Video($item);
            } else if ($item.hasClass('product-content--360')) {
                this.initContentBox_360($item);
            }
        });
    }

    public static init(): void {
        $(() => {
            // const $header = $('.productheader');
            // const id = parseInt($header.data('id'));

            const $iproducask = $('.js-productask');
            const $buttons = $('.vproduct__formshows button, .vproduct__negotiation');

            $iproducask.on('click', (e) => {
                (<any> $).fancybox({
                    href: $iproducask.data('url'),
                });
            });

            $buttons.each((ix, el) => {
                const $btn = $(el);

                $btn.on('click', (e) => {
                    (<any> $).fancybox({
                        href: $btn.data('url'),
                    });
                });
            });

            const $quantity = $('.addtocart__input input');

            (<any> $quantity).qSpinner({
                value: $quantity.val()
            });

            this.initTexts();
            this.initContentBoxes();
            this.initProductGallery();
        });
    }
}
